var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfilePassword = function SvgProfilePassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F0F0F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24h.005M29 24h.005M19 24h.005M17.2 19h13.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C34 20.52 34 21.08 34 22.2v3.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C32.48 29 31.92 29 30.8 29H17.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C14 27.48 14 26.92 14 25.8v-3.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C15.52 19 16.08 19 17.2 19Zm7.05 5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm5 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Zm-10 0a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z",
    stroke: "#4A49BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgProfilePassword;